export const HPUID_LOGIN_URL = process.env.REACT_APP_HPUID_LOGIN_URL;
export const GRAPHQL_BASE_URL = process.env.REACT_APP_GRAPHQL_BASE_URL;
export const GRAPHQL_SECONDARY_URL = process.env.REACT_APP_GRAPHQL_SECONDARY_URL;
export const REACT_APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const REACT_APP_SECONDARY_ENVIRONMENT = process.env.REACT_APP_SECONDARY_ENVIRONMENT;

export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const KB_USER_DATA = "KB_USER_DATA";

export const TOKEN_RENEW_REQUEST = "TOKEN_RENEW_REQUEST";
export const TOKEN_RENEW_SUCCESS = "TOKEN_RENEW_SUCCESS";
export const TOKEN_RENEW_FAIL = "TOKEN_RENEW_FAIL";

export const RECEIVE_ACCESS_TOKEN = "RECEIVE_ACCESS_TOKEN";
export const CLEAR_USER_INFO = "CLEAR_USER_INFO";

export const SET_ALL_USERS = "SET_ALL_USERS";
export const SET_ROLE_LIST = "SET_ROLE_LIST";

export const GET_MODEL_HIERARCHY_REQUEST = "GET_MODEL_HIERARCHY_REQUEST";
export const GET_MODEL_HIERARCHY_SUCCESS = "GET_MODEL_HIERARCHY_SUCCESS";
export const GET_MODEL_HIERARCHY_FAIL = "GET_MODEL_HIERARCHY_FAIL";

export const DELETE_MODEL_HIERARCHY_REQUEST = "DELETE_MODEL_HIERARCHY_REQUEST";
export const DELETE_MODEL_HIERARCHY_SUCCESS = "DELETE_MODEL_HIERARCHY_SUCCESS";
export const DELETE_MODEL_HIERARCHY_FAIL = "DELETE_MODEL_HIERARCHY_FAIL";

export const UPDATE_MODEL_HIERARCHY_REQUEST = "UPDATE_MODEL_HIERARCHY_REQUEST";
export const UPDATE_MODEL_HIERARCHY_SUCCESS = "UPDATE_MODEL_HIERARCHY_SUCCESS"; 
export const UPDATE_MODEL_HIERARCHY_FAIL = "UPDATE_MODEL_HIERARCHY_FAIL";

export const CREATE_MODEL_HIERARCHY_REQUEST = "CREATE_MODEL_HIERARCHY_REQUEST";
export const CREATE_MODEL_HIERARCHY_SUCCESS = "CREATE_MODEL_HIERARCHY_SUCCESS";
export const CREATE_MODEL_HIERARCHY_FAIL = "CREATE_MODEL_HIERARCHY_FAIL";
export const FILTER_MODELHRCY = "FILTER_MODELHRCY";
export const CLEAR_MODELHRCY_FILTERS = 'CLEAR_MODELHRCY_FILTERS';

export const KB_READ_ONLY = "kb_readonly";
export const REGIONAL_READ_ONLY = "regional_readonly";

export const ROLES = {
    ADMIN: 'admin',
    STANDARD: 'standard',
    KB_READONLY: 'kb_readonly',
    REGIONAL: 'regional',
    REGIONAL_READONLY: 'regional_readonly',
    PCX_FILES: 'pcx_files',
    PLC: 'plc',
    PLC_ADMIN: 'plc_admin',
    PLC_REGIONAL: 'plc_regional',
    PLC_AP: 'plc_ap',
    PLC_EU: 'plc_eu',
    PLC_LA: 'plc_la',
    PLC_NA: 'plc_na',
    PLC_WW: 'plc_ww',
    BTP: 'btp'
};

const OCPLC_ROLES=[
    ROLES.PLC,
    ROLES.PLC_ADMIN,
    ROLES.PLC_REGIONAL,
    ROLES.PLC_AP,
    ROLES.PLC_EU,
    ROLES.PLC_LA,
    ROLES.PLC_NA,
    ROLES.PLC_WW
]
 
const KB_ROLES = [
    ROLES.KB_READONLY,
    ROLES.STANDARD
]
 
const REGIONAL_ROLES = [
    ROLES.REGIONAL,
    ROLES.REGIONAL_READONLY
]


export const DEFAULT_ROUTES = {
    [ROLES.ADMIN]: "/admin/users",
    ...KB_ROLES.reduce((acc, role) => ({ ...acc, [role]: "/dashboard" }), {}),
    ...REGIONAL_ROLES.reduce((acc, role) => ({ ...acc, [role]: "/regional" }), {}),
    [ROLES.PCX_FILES]: "/files",
    ...OCPLC_ROLES.reduce((acc, role) => ({ ...acc, [role]: "/ocplc" }), {}),
    [ROLES.BTP]: "/btp"
};

export const ACCESSIBLE_PAGES = {
    [ROLES.ADMIN]: ['admin'],
    ...KB_ROLES.reduce((acc, role) => ({ ...acc, [role]: ['dashboard'] }), {}),
    ...REGIONAL_ROLES.reduce((acc, role) => ({ ...acc, [role]: ['regional'] }), {}),
    [ROLES.PCX_FILES]: ['files'],
    ...OCPLC_ROLES.reduce((acc, role) => ({ ...acc, [role]: ['ocplc'] }), {}),
    [ROLES.BTP]: ['btp']
};

export const USERS = [
    {
        userName: 'John Doe',
        password: '1',
        userEmail: 'test.hp@hp.com',
        roles: ['KB Engineer'],
    },
    {
        userName: 'John Doe',
        password: '1',
        userEmail: 'test.hp@hp.com',
        roles: ['KB Admin'],
    }
];
